import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, RouterModule } from '@angular/router';
import { routes } from './app.routes';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideCalAngular } from '@cvx/cal-angular';
import { HttpUtilityService } from './core/services/app-http.utility.service';
import { LoadingService } from './core/services/app-loading.service';
import { environment } from '../environments/environment';
import { loadingInterceptor } from './core/auth/loading.interceptor';
import { errorInterceptor } from './core/auth/error.interceptor';
import { authInterceptor } from './core/auth/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(BrowserModule, RouterModule),

    provideHttpClient(withInterceptors([loadingInterceptor, errorInterceptor, authInterceptor])),
    provideCalAngular(environment.calConfig),
    HttpUtilityService,
    LoadingService,
  ],
};
